import { useQuery } from '@tanstack/react-query';

import { getTaxEstimation } from '~/services/ConnectionGoogleService';

const taxEstimationQueryKeys = {
  all: ['connection-google', 'tax-estimation'] as const,
};

export function useGetTaxEstimation() {
  return useQuery({
    queryKey: taxEstimationQueryKeys.all,
    queryFn: async ({ signal }) => (await getTaxEstimation(signal)).result,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
